package ru.it_mozaika.sender.js.application.components

import csstype.PropertiesBuilder
import js.core.jso
import kotlinext.js.assign
import mui.material.*
import mui.material.styles.Theme
import mui.material.styles.TypographyVariant
import mui.material.styles.useTheme
import mui.system.Breakpoint
import mui.system.responsive
import mui.system.sx
import react.*
import react.dom.aria.ariaLabel
import react.dom.events.MouseEventHandler
import react.dom.html.ReactHTML
import react.router.useLocation
import react.router.useNavigate
import ru.it_mozaika.sender.common.models.UserRole
import ru.it_mozaika.sender.js.application.context.UserContext
import ru.it_mozaika.sender.js.application.models.*
import web.cssom.AlignItems
import web.cssom.Auto
import web.cssom.Color
import web.cssom.Display
import web.cssom.None
import web.cssom.important
import web.cssom.minus
import web.cssom.number
import web.cssom.px
import web.cssom.rem
import web.cssom.vh
import web.html.HTMLElement
import web.window.WindowTarget

external interface SidebarProps : Props {
    var drawerOpen: Boolean
    var drawerToggle: () -> Unit
}
val Sidebar = FC<SidebarProps> { props ->
    val theme = useTheme<Theme>()
    val matchUpMd = useMediaQuery(theme.breakpoints.up(Breakpoint.md))
    val pathname = useLocation().pathname
    val currentUser = useContext(UserContext).currentUser

    Box {
        component = ReactHTML.nav
        sx {
//            height = 100.vh - 70.px
            flexShrink = responsive(Breakpoint.md to number(0.0))
            width = if (matchUpMd) 260.px else Auto.auto
        }
        ariaLabel = "mailbox folders" // TODO: Why this label?
        Drawer {
            variant = if (matchUpMd) DrawerVariant.persistent else DrawerVariant.temporary
            anchor = DrawerAnchor.left
            open = props.drawerOpen
            onClose = { _, _ -> props.drawerToggle() }
            sx {
                "& .MuiPaper-root"{
                    maxHeight = 100.vh - 100.px
                }
                "& .MuiDrawer-paper" {
                    width = 260.px
                    background = Color(theme.palette.background.default)
                    color = theme.palette.text.primary
                    borderRight = None.none
                    (theme.breakpoints.up(Breakpoint.md)) {
                        top = 88.px
                    }
                }
            }
            ModalProps = jso { keepMounted = true }

            Box {
                sx {
                    display = responsive(Breakpoint.xs to Display.block, Breakpoint.md to None.none)
                }
                Box {
                    sx {
                        display = Display.flex
                        padding = 2.px
                        asDynamic().mx = "auto"
                    }
                    +"Логотип"
                }
            }

            Box {
                sx {
                    height = if (!matchUpMd) (100.vh - 56.px) else (100.vh - 88.px)
                    paddingLeft = 16.px
                    paddingRight = 16.px
                }

                List {
                    subheader = MenuTitle.create()

                    SenderFeatures.values().forEach { feature ->
                        MenuItem {
                            level = 1
                            disabled = false
                            selected = pathname == feature.key
                            icon = feature.icon
                            title = feature.text
                            href = feature.key
                        }
                    }
                }
                Divider {
                    sx {
                        marginTop = 0.25.px
                        marginBottom = 1.25.px
                    }
                }

                List {
                    subheader = MenuTitle.create {
                        title = "Подписки"
                    }

                    SubscribesFeatures.values().forEach { feature ->
                        MenuItem {
                            level = 1
                            disabled = false
                            selected = pathname == feature.key
                            icon = feature.icon
                            title = feature.text
                            href = feature.key
                        }
                    }
                }
                Divider {
                    sx {
                        marginTop = 0.25.px
                        marginBottom = 1.25.px
                    }
                }

                List {
                    subheader = MenuTitle.create {
                        title = "Кампании"
                    }
                    CampaignsFeatures.values().forEach { feature ->
                        MenuItem {
                            level = 1
                            disabled = false
                            selected = pathname == feature.key
                            icon = feature.icon
                            title = feature.text
                            href = feature.key
                        }
                    }
                }
                Divider {
                    sx {
                        marginTop = 0.25.px
                        marginBottom = 1.25.px
                    }
                }
                List {
                    subheader = MenuTitle.create{
                        title = "Шаблоны"
                    }
                    TemplatesFeatures.values().forEach { feature ->
                        MenuItem {
                            level = 1
                            disabled = false
                            selected = pathname == feature.key
                            icon = feature.icon
                            title = feature.text
                            href = feature.key
                        }
                    }
                }
                Divider {
                    sx {
                        marginTop = 0.25.px
                        marginBottom = 1.25.px
                    }
                }

                List {
                    subheader = MenuTitle.create ()
                    TriggersFeatures.values().forEach { feature ->
                        MenuItem {
                            level = 1
                            disabled = false
                            selected = pathname == feature.key
                            icon = feature.icon
                            title = feature.text
                            href = feature.key
                        }
                    }
                }
                Divider {
                    sx {
                        marginTop = 0.25.px
                        marginBottom = 1.25.px
                    }
                }

                List {
                    subheader = MenuTitle.create()
                    FilesFeatures.values().forEach { feature ->
                        MenuItem {
                            level = 1
                            disabled = currentUser?.role != UserRole.Admin
                            selected = pathname == feature.key
                            icon = feature.icon
                            title = feature.text
                            href = feature.key
                        }
                    }
                }
                Divider {
                    sx {
                        marginTop = 0.25.px
                        marginBottom = 1.25.px
                    }
                }

                List {
                    subheader = MenuTitle.create {
                        title = "Система"
                    }
                    AdminFeatures.values().forEach { feature ->
                        MenuItem {
                            level = 1
                            disabled = currentUser?.role != UserRole.Admin
                            selected = pathname == feature.key
                            icon = feature.icon
                            title = feature.text
                            href = feature.key
                        }
                    }
                }
            }
        }
    }
}

external interface MenuTitleProps : Props {
    var title: String
    var subtitle: String
}
private val MenuTitle = FC<MenuTitleProps> { props ->
    val theme = useTheme<Theme>()
    Typography {
        variant = TypographyVariant.caption
        gutterBottom = true
        sx {
            +theme.typography.menuCaption.unsafeCast<PropertiesBuilder>()
            display = Display.block
        }
        if (undefined != props.title) {
            +props.title
        }
        Typography {
            variant = TypographyVariant.caption
            gutterBottom = true
            sx {
                +theme.typography.subMenuCaption.unsafeCast<PropertiesBuilder>()
                display = Display.block
            }
            if (undefined != props.subtitle) {
                +props.subtitle
            }
        }
    }
}

external interface MenuItemProps : Props {
    var level: Int
    var disabled: Boolean
    var selected: Boolean
    var onClick: MouseEventHandler<HTMLElement>
    var icon: ReactElement<SvgIconProps>
    var title: String
    var caption: String
    var href: String
}
private val MenuItem = FC<MenuItemProps> { props ->
    val theme = useTheme<Theme>()
    val navigate = useNavigate()

    ListItemButton {
        asDynamic().component = "a"
        asDynamic().href = props.href
        asDynamic().target = WindowTarget._self
        onClick = {
            it.preventDefault()
            it.stopPropagation()
            navigate(props.href)
        }
        disabled = props.disabled
        sx {
            borderRadius = 8.px
            marginBottom = 4.px
            alignItems = AlignItems.flexStart
            backgroundColor = if (props.level > 1) important(Color("transparent")) else Color("inherit")
            paddingLeft = (props.level * 24).px
        }
        selected = props.selected
        onClick = props.onClick
        ListItemIcon {
            sx {
                marginTop = Auto.auto
                marginBottom = Auto.auto
            }
            child(props.icon.type, assign(props.icon.props) {
                stroke = "1.5"
                sx {
                    fontSize = 1.3.rem
                    +props.icon.props.sx
                }
            })
        }
        ListItemText {
            primary = Typography.create {
                variant = if (props.selected) TypographyVariant.h5 else TypographyVariant.body1
                +props.title
            }
            if (undefined != props.caption) {
                secondary = Typography.create {
                    variant = TypographyVariant.caption
                    sx {
                        +theme.typography.subMenuCaption.unsafeCast<PropertiesBuilder>()
                        display = Display.block
                    }
                    gutterBottom = true
                    +props.caption
                }
            }
        }
    }
}